import { defineComponent as _defineComponent } from 'vue'
import { modalService } from '@/library-services/modal.service';
import { computed, getCurrentInstance } from 'vue';
import AdminNotificationWizard from './AdminNotificationWizard/AdminNotificationWizard.vue';
import * as permissionUtils from '@/utils/permissionUtils';
import { User } from '@/models/user';
import { usersService } from '@/services/users.service';
import { UserType } from '@/models/userType';
import { tenantsService } from '@/services/tenants.service';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN
 * Menu in the page header giving access to several pages to set up the
 * application.
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SettingsMenu',
  setup(__props) {

const { t } = useI18n();

const app = getCurrentInstance();
function openAdminNotificationModal() {
  modalService.compositionApi.open(
    {
      component: AdminNotificationWizard,
    },
    app,
  );
}

const user = computed((): User => usersService.store.current());

const canSendNotifications = computed((): boolean =>
  permissionUtils.hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);

const wccEnabled = computed(() => {
  const customer = tenantsService.store.current();
  return (
    permissionUtils.hasCurrentUserPermission(UserType.CustomerAdmin) &&
    user.value.consoles.includes(ConsoleEnum.WCC) &&
    (!customer || customer.hasDatahub)
  );
});

const canAccessSubsidiaries = computed((): boolean =>
  permissionUtils.hasCurrentUserPermission(UserType.SubsidiaryAdmin),
);

const canAccessCustomers = computed((): boolean =>
  permissionUtils.hasCurrentUserPermission(UserType.CustomerUser),
);

const canAccessUsers = computed((): boolean =>
  permissionUtils.hasCurrentUserPermission(UserType.CustomerAdmin),
);

const canAccessControlList = computed(() =>
  permissionUtils.canAccessControlList(),
);
const canAccessDataPlatforms = computed(() =>
  permissionUtils.canAccessDataPlatforms(),
);

return { __sfc: true,t, app, openAdminNotificationModal, user, canSendNotifications, wccEnabled, canAccessSubsidiaries, canAccessCustomers, canAccessUsers, canAccessControlList, canAccessDataPlatforms }
}

})